
export const testimonials = [
  {
    id: 1,
    name: 'Thandi Mkhize',
    location: 'Westville, Durban',
    rating: 5,
    text: 'Look Who\'s Moving made our house move so easy! They were professional, careful with our furniture, and the price was very affordable. Highly recommend them for anyone in Durban looking for reliable removals.',
    avatar: 'https://public.readdy.ai/ai/img_res/c082415919cb4e76be62ab51260f66ba.jpg',
  },
  {
    id: 2,
    name: 'Johan van der Merwe',
    location: 'Pinetown, KZN',
    rating: 5,
    text: 'Excellent service from start to finish. They arrived on time, handled everything with care, and the team was very friendly. Best bakkie removal service in Pinetown without a doubt!',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20south%20african%20man%20smiling%20portrait%20natural%20lighting%20warm%20friendly%20expression&width=80&height=80&seq=testimonial2&orientation=squarish',
  },
  {
    id: 3,
    name: 'Nomsa Dlamini',
    location: 'Umlazi, Durban',
    rating: 5,
    text: 'I needed to move my furniture from Umlazi to Hillcrest and they did an amazing job. Very affordable prices and no hidden fees. The team was respectful and efficient. Will definitely use them again!',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20south%20african%20woman%20smiling%20portrait%20natural%20lighting%20warm%20friendly%20expression&width=80&height=80&seq=testimonial3&orientation=squarish',
  },
  {
    id: 4,
    name: 'David Naidoo',
    location: 'Hillcrest, KZN',
    rating: 5,
    text: 'Their landscaping service transformed our garden completely. Professional work, fair pricing, and they cleaned up everything afterwards. Highly recommend Look Who\'s Landscaping for any garden work in Durban.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20south%20african%20man%20smiling%20portrait%20natural%20lighting%20warm%20friendly%20expression&width=80&height=80&seq=testimonial4&orientation=squarish',
  },
  {
    id: 5,
    name: 'Sarah Pillay',
    location: 'Durban Central',
    rating: 5,
    text: 'Used them for office furniture removal and they were fantastic. Quick, efficient, and very careful with our equipment. Great communication throughout the process. Best movers in Durban!',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20south%20african%20woman%20smiling%20portrait%20natural%20lighting%20warm%20friendly%20expression&width=80&height=80&seq=testimonial5&orientation=squarish',
  },
];
